<template>
  <div class="the-list">
    <div class="main-page">
      <div
        class="show-pc"
        v-loading="loading"
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
      >
        <el-table :data="data" style="width: 100%" @cell-click="cellClick">
          <el-table-column label="公司编号">
            <template slot-scope="scope">
              <span>{{ scope.row.flow.comNum }}</span>
            </template>
          </el-table-column>
          <el-table-column label="公司名称">
            <template slot-scope="scope">
              <span>{{ scope.row.flow.companyName }}</span>
            </template>
          </el-table-column>
          <el-table-column label="信息类型">
            <template slot-scope="scope">
              <span>{{ scope.row.flow.infoType }}</span>
            </template>
          </el-table-column>
          <el-table-column label="注册资金">
            <template slot-scope="scope">
              <span>{{ scope.row.flow.registeredCapital }}</span>
            </template>
          </el-table-column>
          <el-table-column label="区域">
            <template slot-scope="scope">
              <span>{{ scope.row.flow.province }}/{{ scope.row.flow.city }}/{{ scope.row.flow.county }}</span>
            </template>
          </el-table-column>
          <el-table-column label="纳税性质">
            <template slot-scope="scope">
              <span v-show="scope.row.flow.taxNature === '1'">小规模</span>
              <span v-show="scope.row.flow.taxNature === '2'">一般纳税人</span>
              <span v-show="scope.row.flow.taxNature !== '1' && scope.row.flow.taxNature !== '2'">{{
                scope.row.flow.taxNature
              }}</span>
            </template>
          </el-table-column>
          <el-table-column label="转让价格">
            <template slot-scope="scope">
              <span>{{ scope.row.flow.transferPrice }}</span>
            </template>
          </el-table-column>
          <el-table-column label="联系人">
            <template slot-scope="scope">
              <span>{{ scope.row.flow.linkman }}</span>
            </template>
          </el-table-column>
          <el-table-column width="120" label="联系电话">
            <template slot-scope="scope">
              <span>{{ scope.row.flow.phone }}</span>
            </template>
          </el-table-column>
          <el-table-column v-if="$route.name === 'Flow'" label="是否上架">
            <template slot-scope="scope">
              <span>{{ scope.row.flow.isPublic === '1' ? '是' : '否' }}</span>
            </template>
          </el-table-column>
          <el-table-column v-if="$route.name === 'FlowPublicBySelf'" label="审核状态">
            <template slot-scope="scope">
              <el-tag v-show="scope.row.flow.auditStatus === '0'" size="mini" type="warning">待审核</el-tag>
              <el-tag v-show="scope.row.flow.auditStatus === '1'" size="mini" type="success">已通过</el-tag>
              <el-tag v-show="scope.row.flow.auditStatus === '2'" size="mini" type="danger">未通过</el-tag>
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" :width="rightWidth">
            <template slot-scope="scope">
              <slot name="button" v-bind:scope="scope"></slot>
              <!-- <el-button
                v-if="$route.name === 'FlowPublic'"
                size="mini"
                type="primary"
                plain
                @click="handleEdit(scope.$index, scope.row.flow)"
                >查看</el-button
              >
              <el-button
                v-else
                v-permissions="'transfer:update'"
                size="mini"
                type="primary"
                plain
                @click="handleEdit(scope.$index, scope.row.flow)"
                >编辑</el-button
              >
              <el-button
                v-permissions="'transfer:delete'"
                size="mini"
                plain
                type="danger"
                @click="handleDelete(scope.$index, scope.row.flow)"
                >删除</el-button
              > -->
            </template>
          </el-table-column>
        </el-table>
        <div class="page">
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="page"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="pageSize"
            layout="total, prev, pager, next, sizes, jumper"
            :total="total"
          >
          </el-pagination>
        </div>
      </div>
      <!-- 移动端 -->
      <div
        class="show-phone"
        v-loading="loading"
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
      >
        <van-pull-refresh v-model="vrefreshing" @refresh="onRefresh">
          <van-list v-model="vloading" :finished="finished" finished-text="没有更多了" @load="onLoad">
            <ul class="phone-list">
              <li v-for="(item, index) in data" :key="index" @click="handleEdit(index, item.flow)">
                <div class="title">
                  <span class="text">{{ item.flow.companyName }}</span>
                  <span class="phone">
                    <a :href="'tel:' + item.flow.phone">
                      <el-tag> <i class="el-icon-phone-outline"></i>电话 </el-tag>
                    </a>
                  </span>
                </div>
                <div class="label">
                  <el-tag size="mini" type="success" effect="dark">
                    转让
                  </el-tag>
                  <el-tag v-show="item.flow.county" size="mini" type="primary" effect="dark">
                    {{ item.flow.county }}
                  </el-tag>
                </div>
                <div class="content">
                  <div class="item">
                    <div class="label">纳税性质</div>
                    <div>
                      <span v-if="item.flow.taxNature == '1'">小规模</span>
                      <span v-else-if="item.flow.taxNature == '2'">一般纳税人</span>
                      <span v-else>{{ item.flow.taxNature }}</span>
                    </div>
                  </div>
                  <div class="item">
                    <div class="label">成立日期</div>
                    <div>{{ item.flow.establishmentTime && item.flow.establishmentTime.substring(0, 10) }}</div>
                  </div>
                  <div class="item">
                    <div class="label">转让费</div>
                    <div>{{ item.flow.transferPrice }}</div>
                  </div>
                </div>
              </li>
            </ul>
          </van-list>
        </van-pull-refresh>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'R',
  props: {
    data: {
      type: Array,
      required: true
    },
    page: {
      type: Number,
      default: 1
    },
    pageSize: {
      type: Number,
      default: 10
    },
    finished: {
      type: Boolean,
      default: false
    },
    listloading: {
      type: Boolean,
      default: false
    },
    refreshing: {
      type: Boolean,
      default: false
    },
    showSizeChanger: {
      type: Boolean,
      default: true
    },
    total: {
      type: Number,
      default: 0
    },
    rightWidth: {
      type: String,
      default: '150px'
    }
  },
  data() {
    return {
      userInfo: {},
      web: 'main',
      loading: false,
      vloading: false,
      vrefreshing: false
    }
  },
  watch: {
    listloading: {
      handler(newVal, oldVal) {
        this.vloading = newVal
      },
      immediate: true,
      deep: true
    },
    refreshing: {
      handler(newVal, oldVal) {
        console.log('refreshing: ' + newVal)
        this.vrefreshing = newVal
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    cellClick(row, column, cell, event) {
      if (column.label !== '操作' && column.label !== '图片') {
        this.$emit('handleDetail', column.index, row.flow)
      }
    },
    // 每页条数切换
    handleSizeChange(val) {
      this.$emit('size-change', val)
    },
    // 页码切换
    handleCurrentChange(val) {
      this.$emit('current-change', val)
    },
    // 客户编辑
    handleEdit(index, row) {
      this.$emit('handleEdit', index, row)
    },
    // 客户详情
    handleDetail(index, row) {
      this.$emit('handleDetail', index, row)
    },
    // 删除客户
    handleDelete(index, row) {
      this.$root.$children[0].vueConfirm(
        { message: '确认要删除此客户吗?' },
        () => {
          const param = {
            id: row.id
          }
          this.$get('/flow/delete', param).then(
            result => {
              if (result.status === 200) {
                this.$emit('search')
                this.$root.$children[0].vueAlert({ message: result.msg, type: 'success' })
              } else {
                this.$root.$children[0].vueAlert({ message: result.msg, type: 'error' })
              }
            },
            error => {
              this.$root.$children[0].vueAlert({ message: error.name + ':' + error.message, type: 'error' })
            }
          )
        },
        () => {
          return console.log('取消删除')
        }
      )
    },
    onLoad(type) {
      console.log(type)
      this.$emit('onLoad', type)
    },
    onRefresh() {
      // 清空列表数据
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.$emit('refresh')
    }
  },
  mounted() {},
  beforeDestroy() {}
}
</script>

<style lang="less" scoped>
.el-radio-group {
  /deep/.el-radio {
    margin-right: 10px;
    margin-top: 5px;
    margin-bottom: 5px;
    .el-radio__label {
      padding-left: 0;
    }
    .el-radio__input {
      display: none;
    }
  }
  .el-radio.is-bordered + .el-radio.is-bordered {
    margin-left: 0;
  }
}

.show-phone {
  .el-date-editor.el-input,
  .el-date-editor.el-input__inner {
    width: 100%;
    .el-input__prefix {
      height: 34px;
    }
  }
}
.el-autocomplete-suggestion.el-popper {
  width: 300px !important;
}
.import-btn {
  position: relative;
  .import-excel {
    position: absolute;
    width: 100%;
    height: 100%;
    opacity: 0;
    left: 0;
    top: 0;
  }
}
.edit-page,
.main-page {
  height: 100%;
}
.title {
  text-align: center;
  font-size: 28px;
  padding: 24px;
}
.btn-search {
  display: flex;
  margin: 0 auto;
  justify-content: center;
  .simple {
    width: 550px;
  }
  .advanced {
    cursor: pointer;
    width: 100px;
    margin-left: 10px;
    color: black;
    text-decoration: underline;
    font-size: 14px;
    line-height: 50px;
  }
  /deep/.el-input-group__append,
  /deep/.el-input-group__prepend {
    color: #fff;
    background-color: #1890ff;
    border-color: #1890ff;
  }
  .el-button {
    color: #fff;
    background-color: #1890ff;
    border-color: #1890ff;
  }
}
.advanced {
  cursor: pointer;
  width: 100px;
  margin-left: 10px;
  color: black;
  text-decoration: underline;
  font-size: 14px;
  margin-bottom: 10px;
}
.phone-list {
  color: #000;
  li {
    padding: 0 10px;
    border-bottom: 1px solid #eee;
    background: #fff;
    .title {
      display: flex;
      font-size: 0.8vw;
      font-weight: normal;
      text-align: left;
      padding: 0;
      padding-top: 10px;
      justify-content: space-between;
      .text {
        width: calc(100% - 100px);
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        line-height: 2;
      }
      .phone {
        a {
        }
      }
    }
    .label {
      /deep/.el-tag {
        margin-right: 10px;
      }
    }
    .content {
      display: flex;
      justify-content: center;
      margin-top: 10px;
      .item {
        width: 33%;
        text-align: center;
        line-height: 2;
        .label {
          color: #666;
        }
      }
    }
  }
}
@media screen and (max-width: 768px) {
  .title {
    font-weight: 700;
    font-size: 1.4rem !important;
    line-height: 2 !important;
    margin-bottom: 0;
    height: auto !important;
  }
  .the-list {
    padding: 0 0 20px;
  }
}
</style>
